export default __webpack_public_path__ + "static/media/feather _ user.9127d78c.svg";